export * from "./clsx";
export * from "./referral";

export function onBtnClick(
  f: () => Promise<void> | void,
  errorHandler?: (e: any) => void
): (e: React.MouseEvent) => void {
  return (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    Promise.resolve(f()).catch((e) => {
      console.log("[BtnClick] got error", e);
      if (errorHandler) errorHandler(e);
    });
  };
}
